/**
 * 3.1.1.4 IPv6 방화벽 고급 설정 Store
 *
 * @since 2017-12-12
 * @author devp020
 */

import {i18n} from '~/plugins/i18n'

const initFwAdSettingsData = () => {
  return {
    device_id_list: [],
    device_list_name: '',
    fw6_opt_cm_desc: '',
    fw6_opt_cm_device: [],
    fw6_opt_cm_id: 0,
    fw6_opt_cm_packet_all_frag_allow_yn: 0,
    fw6_opt_cm_packet_first_frag_chk_yn: 0,
    fw6_opt_cm_packet_sync_yn: 0,
    fw6_opt_cm_ps_ftp_yn: 0,
    fw6_opt_cm_ps_sync_yn: 0,
    fw6_opt_cm_ps_tr_yn: 0,
    fw6_opt_cm_rule_any_rule_yn: 0,
    fw6_opt_cm_rule_apply_popup_yn: 0,
    fw6_opt_cm_rule_auto_use_yn: 0,
    fw6_opt_cm_rule_backup_use_yn: 0,
    fw6_opt_cm_rule_except_yn: 0,
    fw6_opt_cm_rule_sess_mng_type: 1,
    fw6_opt_cm_rule_shadow_rule_yn: 0,
    fw6_opt_cm_rule_sync_yn: 0,
    fw6_opt_cm_sess_limit_all_cnt: 1000,
    fw6_opt_cm_sess_limit_rule_cnt: 120,
    fw6_opt_cm_sess_limit_type: 0,
    fw6_opt_cm_sess_sync_yn: 0,
    // fw6_opt_cm_tcp_log_sync_yn: 0,
    // fw6_opt_cm_tcp_log_yn: 0,
    fw6_opt_cm_uname: '',
    fw6_opt_cm_web_cog_yn: 0,
    fw6_opt_cm_web_log_yn: 0,
    fw6_opt_cm_web_sync_yn: 0,
    fw6_opt_cm_x_forwrd_con_yn: 0,
    fw6_opt_cm_x_forwrd_log_yn: 0,
    fw6_opt_cm_x_forwrd_sync_yn: 0,
    fw6_opt_cm_x_forwrd_user_yn: 0,

    // Hitcount 관련 설정
    fw6_opt_cm_rule_hit_perd1: 1,
    fw6_opt_cm_rule_hit_perd2: 7,
    fw6_opt_cm_rule_hit_perd3: 30,
    fw6_opt_cm_rule_hit_perd4: null,
    fw6_opt_cm_rule_hit_perd5: null,

    fw6_opt_cm_rule_any_col_check: '11111',
    fw6_opt_cm_unuse_sync_yn: 0,
    fw6_opt_cm_unuse_auto_disable_use_yn: 0,
    fw6_opt_cm_unuse_date: 50,
    fw6_opt_cm_unuse_recent_yn: 0,
    fw6_opt_cm_unuse_schedule_week: '0000000',
    fw6_opt_cm_unuse_schedule_tm: '0000',

    fw6_opt_cm_tmprule_sync_yn: 0,
    fw6_opt_cm_tmprule_auto_commit_use_yn: 0,
    fw6_opt_cm_tmprule_schedule_week: '0000000',
    fw6_opt_cm_tmprule_schedule_tm: '0000'
  }
}
export const state = () => ({
  // api url 목록
  apiUrl: {
    firewallAdSettingsUrl: '/api/cm/fw6-opt-cm'
  },

  firewallAdSettingsList: [],
  selectedData: initFwAdSettingsData(),
  firewallAdSettingsResult: null,
  postTwoLayerDefenseResult: null,
  selectRowItem: {},
  errorMessage: null
})

export const mutations = {
  // Row DoubleClick
  setSelectRowItem (state, data) {
    state.selectRowItem = data
  },
  // 세션 제한 설정 변경
  changeSessionLimit (state, data) {
    state.selectedData.fw6_opt_cm_sess_limit_type = data
  },
  parseTimeData (state, data) {
    state.selectedData.fw6_opt_cm_unuse_schedule_tm = data
  },
  parseTimeData2 (state, data) {
    state.selectedData.fw6_opt_cm_tmprule_schedule_tm = data
  },
  changeAutoDisable (state, data) {
    state.selectedData.fw6_opt_cm_unuse_auto_disable_use_yn = data
  },
  changeAutoCommit (state, data) {
    state.selectedData.fw6_opt_cm_tmprule_auto_commit_use_yn = data
  },
  // 방화벽 고급 설정 조회
  mutFirewallAdSettings (state, payload) {
    state.firewallAdSettingsList = payload.filter(item => {
      item.device_id_list = '<div>' + item.fw6_opt_cm_device.map(item => {
        return item.device_uname
      }).join('</div><div>') + '</div>'
      return item
    })
  },
  // 동기화 전체 사용/사용 안 함 적용.
  changeAllSyncYn (state, data) {
    const fwAdSettingsData = _.cloneDeep(state.firewallAdSettingsList)
    _.forEach(fwAdSettingsData, row => {
      row.fw6_opt_cm_sync_yn = data
    })
    state.firewallAdSettingsList = fwAdSettingsData
  },
  // 방화벽 고급 설정 편집 데이터 조회
  mutFirewallAdSettingsGetData (state, data) {
    const selectedRowData = data[0]
    const deviceInfo = selectedRowData.fw6_opt_cm_device
    const deviceID = []
    if (deviceInfo.length > 0) {
      const deviceName = deviceInfo[0].device_uname
      const deviceLen = deviceInfo.length
      let result = void 0
      if (deviceLen > 1) {
        result = i18n.t('cmn.deviceTypeText', {name: deviceName, cnt: deviceLen - 1})
      } else if (deviceLen === 1) {
        result = `${deviceName}`
      } else {
        result = ''
      }
      selectedRowData.device_list_name = result
      for (const key of deviceInfo) {
        deviceID.push(key.device_id)
      }
    } else {
      selectedRowData.device_list_name = ''
    }
    state.selectedData = selectedRowData
    state.selectedData.device_id_list = deviceID
  },
  // 방화벽 고급 설정 편집 데이터 초기화
  mutFirewallAdSettingsResetData (state) {
    state.selectedData = initFwAdSettingsData()
  },
  // 방화벽 고급 설정 빈설정
  mutAddEmptySettings: (state, item) => {
    state.firewallAdSettingsList.push(item)
  },
  // 방화벽 고급 설정 완료 처리 / 수정
  mutPutFirewallAdSettings (state, payload) {
    state.firewallAdSettingsResult = payload
  },
  // 방화벽 고급 설정 삭제
  mutDelFirewallAdSettings (state, itemIndexList) {
    itemIndexList = itemIndexList.sort().reverse()
    for (const itemIndex of itemIndexList) {
      state.firewallAdSettingsResult.splice(itemIndex, 1)
    }
  },
  // 방화벽 고급 설정 사용여부 수정
  mutPostFirewallAdSettings (state, payload) {
    state.postTwoLayerDefenseResult = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  },
  resetTargetDeviceData (state) {
    state.selectedData.device_list_name = []
    state.selectedData.device_id_list = []
    state.selectedData.fw6_opt_cm_device = []
  }
}

export const actions = {
  async applyAction () {
    const result = await this.$axios.$put(`/api/cm/fw6-opt-cm/apply`, null, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async cancelAction () {
    const result = await this.$axios.$put(`/api/cm/fw6-opt-cm/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  // 방화벽 고급 설정 조회
  async acsFirewallAdSettings ({commit, state}) {
    let res = {}
    try {
      res = await this.$axios.$get(`${state.apiUrl.firewallAdSettingsUrl}/0`)
      if (res.code === 'ok') {
        commit('mutFirewallAdSettings', res.result)
      } else {
        commit('mutFirewallAdSettings', [])
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
    return res
  },
  // 방화벽 고급 설정 편집 데이터 조회
  async acsFirewallAdSettingsGetData ({commit, state}, optCmId) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.firewallAdSettingsUrl}/${optCmId}`)
      if (res.code === 'ok') {
        commit('mutFirewallAdSettingsGetData', res.result)
      } else {
        commit('mutFirewallAdSettingsGetData', {})
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 방화벽 고급 설정 빈설정
  async acsAddEmptySettings ({commit, state}) {
    const param = _.omit(state.selectedData, [
      'fw6_opt_cm_id',
      'fw6_opt_cm_device',
      'device_list_name',
      'fw6_opt_cm_rule_hit_after_tm'
    ])
    const result = { error: null }
    try {
      const res = await this.$axios.$post(`${state.apiUrl.firewallAdSettingsUrl}`, param, {loading: false, successAlert: false})
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 방화벽 고급 설정 완료 처리 / 수정
  async acsPutFirewallAdSettings ({commit, state}) {
    const result = { error: null }
    const params = _.omit(state.selectedData, [
      'fw6_opt_cm_device',
      'device_list_name',
      'fw6_opt_cm_rule_hit_after_tm'
    ])
    try {
      const res = await this.$axios.$put(`${state.apiUrl.firewallAdSettingsUrl}`, params, {successAlert: false})
      if (res.code === 'ok') {
        commit('mutPutFirewallAdSettings', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 방화벽 고급 설정 삭제
  async acsDelFirewallAdSettings ({commit, state}, param) {
    const result = { error: null }
    const etcParam = param.etcParam
    let res = null
    try {
      if (etcParam !== undefined) {
        res = await this.$axios.$put(`${state.apiUrl.firewallAdSettingsUrl}/multi`, param.idList, etcParam, {successAlert: false})
      } else {
        res = await this.$axios.$put(`${state.apiUrl.firewallAdSettingsUrl}/multi`, param.idList, {successAlert: false})
      }
      if (res.code === 'ok') {
        commit('mutDelFirewallAdSettings', param.idList)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
    return res
  },
  // 방화벽 고급 설정 사용여부 수정
  async acsPostFirewallAdSettings ({commit, state}, payload) {
    const result = { error: null }
    try {
      const res = await this.$axios.$post(`${state.apiUrl.firewallAdSettingsUrl}/multi`, payload)
      if (res.code === 'ok') {
        commit('mutPostFirewallAdSettings', res)
      } else {
        result.error = res.result.msg
        commit('mutationErrorMessage', result)
      }
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  async onEventRuleChkInputAxios ({commit, state}, param) {
    try {
      const data = await this.$axios.$post(`${state.apiUrl.firewallAdSettingsUrl}/multi`, param, {loading: false, successAlert: false})

      if (data.code !== 'ok') {
        return false
      }
      return data
    } catch (error) {
      return error
    }
  }
}

export const strict = false
